<template>
    <div class="container">
        <a-alert
            message="平台范围内的所有交易信息，包括充值、付款、退款等等都会在此进行汇总。收支、以及交易类型是以对应客户视角为标准进行统计。"
            type="info"
            show-icon
            banner
        />

        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-divider type="vertical" class="item" />

                <a-select class="item" v-model="channel" style="width:120px;" @change="(e) => on_field_change(e, 'channel')">
                    <a-select-option value>支付方式</a-select-option>

                    <a-select-option value="alipay">支付宝</a-select-option>
                    <a-select-option value="llpay">网上银行</a-select-option>
                    <a-select-option value="manual">人工扣款</a-select-option>
                    <a-select-option value="system">系统</a-select-option>
                </a-select>

                <a-popover title="选择销售" :getPopupContainer="(trigger) => trigger.parentNode" style="width:120px;">
                    <template slot="content">
                        <div v-if="basic_data_user.length" style="max-width:480px;margin-bottom:12px">
                            <a-checkable-tag
                                class="r-checkbox checkbox-tag"
                                v-for="item in basic_data_user"
                                :key="item.id"
                                :checked="search_seller_ids.some((v) => v == item.id)"
                                @change="(e) => on_mutli_field(e, item.id, 'search_seller_ids')"
                                >{{ item.name }}</a-checkable-tag
                            >
                        </div>

                        <a-button
                            type="primary"
                            size="small"
                            @click="on_mutli_search('search_seller_ids', 'seller_id')"
                            style="margin-right:12px"
                            >搜索</a-button
                        >
                        <a-button size="small" @click="on_reset_field('seller_id')">清除搜索</a-button>
                    </template>
                    <a-button
                        v-if="basic_data_user.length"
                        class="item slice"
                        :ghost="!!search_seller_ids.length"
                        :type="!!search_seller_ids.length ? 'primary' : 'default'"
                    >
                        选择销售
                        <a-icon type="caret-down" />
                    </a-button>
                </a-popover>
            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索流水信息" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <div class="main">
            <a-tabs default-active-key="" v-model="type" @change="(e) => on_field_change(e, 'type')">
                <a-tab-pane key="" tab="全部交易"> </a-tab-pane>
                <a-tab-pane key="recharge" tab="线上充值"> </a-tab-pane>
                <a-tab-pane key="recharge_manual" tab="人工充值"> </a-tab-pane>
                <a-tab-pane key="refund" tab="退款"> </a-tab-pane>
                <a-tab-pane key="deposit" tab="首款"> </a-tab-pane>
                <a-tab-pane key="retainage" tab="尾款"> </a-tab-pane>
            </a-tabs>

            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="transaction_no"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
                :scroll="{ x: true }"
            >
                <template slot="withdraw" slot-scope="text">
                    <template v-if="text">
                        <a-tag color="green" class="b-tag" v-if="text.status == 1">已提现</a-tag>
                        <a-tag class="b-tag" v-if="text.status == 0">处理中</a-tag>
                        <a-tag color="red" class="b-tag" v-if="text.status == -1">失败</a-tag>
                    </template>
                </template>

                <template slot="order" slot-scope="text, record">
                    <div class="tbox" v-if="record.order">
                        <a class="a" style="display: block;" :href="`/order/${record.order_no}`" target="_blank">{{ record.order_no }}</a>
                        <div class="b">
                            <a-icon type="check-circle" v-if="text.status == 1" style="margin-right:4px;color:#4CAF50" />
                            <a-icon type="close-circle" v-if="text.status == -1" style="margin-right:4px;color:#F44336" />
                            <span v-if="text.status == 1">已完成</span>
                            <span v-if="text.status == -1">已取消</span>
                        </div>
                    </div>
                </template>

                <template slot="member" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>
                <template slot="supplier" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.contact_name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>
                <template slot="created" slot-scope="text, record">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ moment(text * 1000).format("YYYY-MM-DD HH:mm") }}</div>
                        <div class="b">{{ record.user ? record.user.name : "[客户本人]" }}</div>
                    </div>
                </template>

                <template slot="seller" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">{{ text.group ? text.group.name : "" }}</div>
                    </div>
                </template>

                <template slot="screenshot" slot-scope="text, record">
                    <a v-if="text" :href="text" target="_blank">查看</a>
                </template>

                <template slot="sort" slot-scope="text, record, index">
                    <div class="sort">
                        <a-button
                            shape="circle"
                            icon="arrow-down"
                            size="small"
                            @click="on_sort(record, 'down', index)"
                            v-if="index != data_source.length - 1"
                        />
                        <a-button shape="circle" icon="arrow-up" size="small" @click="on_sort(record, 'up', index)" v-if="index != 0" />
                    </div>
                </template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="action">
                        <a-button size="small" style="margin-right: 5px" @click="on_edit(record)">修改</a-button>
                        <a-button size="small" @click="on_delete(record)" type="danger" :disabled="!!record.member_count">删除</a-button>
                    </div>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import commonjs from "../mixins/common";

    export default {
        mixins: [common_pagination, commonjs],
        data() {
            return {
                path: "/finance/transaction",
                data_source: [],
                loading: false,
                mode_create: "create",
                selected_record: null,
                wd: null,
                type: "",
                channel: "",
                search_seller_ids: [],
                columns: [
                    {
                        dataIndex: "transaction_no",
                        width: 170,
                        title: "流水号",
                        class: "small",
                        fixed: "left",
                    },
                    {
                        dataIndex: "order",
                        width: 180,
                        title: "关联订单",
                        scopedSlots: {
                            customRender: "order",
                        },
                    },
                    {
                        dataIndex: "member",
                        width: 110,
                        title: "客户",
                        scopedSlots: {
                            customRender: "member",
                        },
                    },
                    {
                        dataIndex: "seller",
                        width: 110,
                        title: "销售",
                        scopedSlots: {
                            customRender: "seller",
                        },
                    },
                    {
                        dataIndex: "supplier",
                        width: 110,
                        title: "供应商",
                        scopedSlots: {
                            customRender: "supplier",
                        },
                    },
                    {
                        dataIndex: "object_text",
                        width: 80,
                        title: "收支类型",
                    },
                    {
                        dataIndex: "type_text",
                        width: 80,
                        title: "交易类型",
                    },
                    {
                        dataIndex: "channel_text",
                        width: 80,
                        title: "支付方式",
                    },
                    {
                        dataIndex: "amount",
                        width: 90,
                        title: "交易金额",
                        customRender: (e) => `¥ ${e || "-"}`,
                    },
                    {
                        dataIndex: "use_balance",
                        width: 80,
                        title: "使用余额",
                        customRender: (e) => (e > 0 ? e : "-"),
                    },
                    // {
                    //     dataIndex: "withdraw",
                    //     width: 80,
                    //     title: "提现状态",
                    //     scopedSlots: {
                    //         customRender: "withdraw",
                    //     },
                    // },
                    // {
                    //     dataIndex: "member_balance",
                    //     width: 80,
                    //     title: "交易后余额",
                    // },

                    {
                        dataIndex: "paid_at",
                        width: 130,
                        title: "交易时间",
                        scopedSlots: {
                            customRender: "created",
                        },
                    },
                    {
                        dataIndex: "screenshot",
                        width: 80,
                        title: "截图凭证",
                        scopedSlots: {
                            customRender: "screenshot",
                        },
                    },
                    {
                        dataIndex: "audit_status_text",
                        width: 80,
                        title: "审批状态",
                    },
                    {
                        dataIndex: "auditor.name",
                        width: 80,
                        title: "审核人",
                    },
                    {
                        dataIndex: "executed_at",
                        width: 140,
                        title: "处理时间",
                        customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD HH:mm") : ""),
                    },
                    {
                        dataIndex: "failure_msg",
                        title: "错误信息",
                    },
                    {
                        dataIndex: "remark",
                        title: "订单备注",
                    },
                    {
                        title: "创建时间",
                        dataIndex: "created_at",
                        customRender: (e) => moment(e * 1000).format("YYYY-MM-DD HH:mm"),
                    },
                    // {
                    //     dataIndex: "action",
                    //     title: "操作",
                    //     align: "center",
                    //     width: 120,
                    //     scopedSlots: {
                    //         customRender: "action"
                    //     }
                    // }
                ],
            };
        },
        created() {
            this.load();
            this.reset_query();

            this.$store.commit("change_state", {
                name: "sidebar_finance",
                value: "transaction",
            });
        },
        watch: {
            $route() {
                this.load();
                this.reset_query();
            },
        },
        methods: {
            moment,
            reset_query() {
                let query = this.$route.query;

                this.wd = "wd" in query ? query["wd"] : "";
                this.type = Object.prototype.hasOwnProperty.call(query, "type") ? query["type"] : "";
                this.channel = Object.prototype.hasOwnProperty.call(query, "channel") ? query["channel"] : "";

                this.search_seller_ids = Object.prototype.hasOwnProperty.call(query, "seller_id") ? query["seller_id"].split(",") : [];
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/finance/transaction?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };

                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        /deep/.ant-tabs-bar {
            margin: 0 !important;
        }
        .main {
            top: 92px;
        }
        .action {
            width: 120px;
        }
        .sort {
            display: flex;
            justify-content: space-around;
        }
        .order {
            .name {
                font-size: 13px;
                margin-bottom: 2px;
            }
            .detail {
                font-size: 12px;
                color: #00000080;
                display: flex;
                > .anticon {
                    padding-top: 8px;
                }
            }
        }
    }
</style>
